// import { CMAAuth } from 'root/services';
import { CMAHttpClient } from './Client';

export const cmaHttpClient = CMAHttpClient({
  baseURL: process.env.BASE_URL_API,
  mockBaseURL: process.env.MOCK_BASE_URL_API,
  // authService: CMAAuth
});
